import { COMMERCIAL_CRYPTO_ASSETS_COMPONENT } from 'constants/flagBasedMBFeatures';

require('./globalPositionInvestments.scss');

// @vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const includes = require('lodash/collection/includes');
const some = require('lodash/collection/some');

// @core
const { formatText } = require('core/i18n').i18n;

// @components
const GlobalPositionFinancialCard = require('components/globalPosition/globalPositionFinancialCard/globalPositionFinancialCard');
const GlobalPositionInvestmentsContentCC = require('components/contactCenter/globalPositionInvestmentsContentCC/globalPositionInvestmentsContentCC');
const { CryptoAssetsBalance } = require('components/globalPosition/globalPositionFinancialCard/cryptoAssets/cryptoAssetsBalance')

// @constants
const { EURO_TEXT, PLURAL_CHARACTER, OPENBANK_PRODUCT_WEALTH } = require('constants/index');
const { YOUR_INVESTMENTS, NOT_ALLOWED_NEW_PG_WEALTH_COUNTRIES } = require('constants/flagBasedFeatures');

class GlobalPositionInvestments extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleBoxClick = this.handleBoxClick.bind(this);
        this.buildCryptoAssetsBalance = this.buildCryptoAssetsBalance.bind(this);
    }

    buildCryptoAssetsBalance() {
        const { wealthDataFF, wealthErrorFF } = this.props;
        const cryptocurrenciesTotalFF = wealthDataFF.get('cryptocurrenciesTotal') || 0;

        return (
            <div className="glb-position-financial-card-item">
                <CryptoAssetsBalance balance={cryptocurrenciesTotalFF} isFetchError={wealthErrorFF} />
            </div>
        );
    }

    getProducts(roboProductOnly) {
        const { immWalletSummarization, immWealthRoboValues, isRoboEnabled, flagBasedFeatures, immFlagBasedMBFeatures, wealthDataFF, wealthErrorFF } = this.props;

        if (!immWalletSummarization) {
            return [];
        }

        let products = [];

        if(roboProductOnly && isRoboEnabled) {
            let roboAmmount = immWealthRoboValues.get('totalDiscrecionalAmount') || 0;
            products = [{
                title: formatText(`myGlobalPosition-myGlobalPosition_linkToRoboInvestment`),
                amount: roboAmmount,
                currency: EURO_TEXT,
                link: `/myprofile/broker/general/robo`
            }];

            return products;
        }

        const immValues = immWalletSummarization.get('values');
        const immFunds = immWalletSummarization.get('funds');
        const immPlans = immWalletSummarization.get('plans');
        const immFutures = immWalletSummarization.get('futures');
        let investmentsAmmount = 0;
        let roboAmmount = immWealthRoboValues.get('totalDiscrecionalAmount') || 0;
        let youInvestTotalFF = wealthDataFF.get('youInvestTotal') || 0;
        let weInvestForYouTotalFF = wealthDataFF.get('weInvestForYouTotal') || 0;
        const hasCryptoAssets = wealthDataFF.get('hasCryptoAssets');

        let newPGWealthFF = flagBasedFeatures.get(NOT_ALLOWED_NEW_PG_WEALTH_COUNTRIES);
        const cryptoAssets = immFlagBasedMBFeatures.get(COMMERCIAL_CRYPTO_ASSETS_COMPONENT);


        if (immValues.get('quantity')) {
            investmentsAmmount += immValues.getIn(['balance', 0]).get('amount');
        }

        if (immFunds.get('quantity')) {
            investmentsAmmount += immFunds.getIn(['balance', 0]).get('amount');
        }

        if (immPlans.get('quantity')) {
            investmentsAmmount += immPlans.getIn(['balance', 0]).get('amount');
        }

        if (immFutures.get('quantity')) {
            investmentsAmmount += immFutures.getIn(['balance', 0]).get('amount');
        }

        products = [
            {
                title: formatText(`myGlobalPosition-myGlobalPosition_linkToDefaultInvestment`),
                amount: newPGWealthFF && !wealthErrorFF  ? youInvestTotalFF : investmentsAmmount,
                currency: EURO_TEXT,
                link: `/myprofile/broker`
            },

        ];

        if (cryptoAssets && (hasCryptoAssets || wealthErrorFF)) {
            products.push({
                isComponent: true,
                component: this.buildCryptoAssetsBalance(),
            })
        }

        if (isRoboEnabled){
            products.push({
                title: formatText(`myGlobalPosition-myGlobalPosition_linkToRoboInvestment`),
                amount: newPGWealthFF && !wealthErrorFF ? weInvestForYouTotalFF : roboAmmount,
                currency: EURO_TEXT,
                link: `/myprofile/broker/general/robo`
            })
        }

        return products;
    }

    getTotal() {
        const { immWalletSummarization, immWealthRoboValues, wealthDataFF,wealthErrorFF, flagBasedFeatures } = this.props;
        if (!immWalletSummarization) {
            return [];
        }
        let newPGWealthFF = flagBasedFeatures.get(NOT_ALLOWED_NEW_PG_WEALTH_COUNTRIES);
        let totalFF = wealthDataFF.get('total') || 0;
        let total = 0;
        [
            immWalletSummarization.getIn(['values', 'balance', '0']),
            immWalletSummarization.getIn(['futures', 'balance', '0']),
            immWalletSummarization.getIn(['plans', 'balance', '0']),
            immWalletSummarization.getIn(['funds', 'balance', '0']),
            immWealthRoboValues.getIn(['balance', '0'])
        ].forEach(item => {
            total += item.get('amount');
        });

        //This is a temporary solution until privada site exclude futures in it's total calculation
        let ccTotal = 0;
        [
            immWalletSummarization.getIn(['values', 'balance', '0']),
            immWalletSummarization.getIn(['plans', 'balance', '0']),
            immWalletSummarization.getIn(['funds', 'balance', '0'])
        ].forEach(item => {
            ccTotal += item.get('amount');
        });

        return [
            {
                // (Andres): All items are in EUR so we take any one.
                currency: immWalletSummarization.getIn(['values', 'balance', '0', 'currency']),
                amount: !__CONTACT_CENTER__ ? newPGWealthFF && !wealthErrorFF ? totalFF :total : ccTotal,
                legend: formatText('myGlobalPosition-savingsTotal')
            }
        ];
    }

    handleBoxClick(evt) {
        const linkToInvesmentsView = '/myprofile/broker/general';
        const classListWithoutRedirect = [
            'ok-collapsing-toggler'
        ];
        if (!some(evt.target.parentElement.classList, (el) => includes(classListWithoutRedirect, el))) {
            this.props.history.push(linkToInvesmentsView);
        }
    }

    render() {
        const { expanded, immWalletSummarization, immWealthRoboValues, isRoboEnabled, flagBasedFeatures, wealthDataFF } = this.props;

        const total = this.getTotal();

        const immValues = immWalletSummarization.get('values');
        const immFunds = immWalletSummarization.get('funds');
        const immPlans = immWalletSummarization.get('plans');
        const immFutures = immWalletSummarization.get('futures');
        const hasCryptoAssets = wealthDataFF.get('hasCryptoAssets')

        const excludedItems = immWalletSummarization.get('excludedProducts');
        const pluralPostfix = excludedItems !== 1 ? PLURAL_CHARACTER : '';
        const subtitle =
            excludedItems > 0
                ? formatText('myGlobalPosition-excludedInvestments', [
                      excludedItems,
                      pluralPostfix,
                      pluralPostfix
                  ])
                : '';
        const hasExcludedItems = excludedItems > 0;

        //This change will be temporary until "privada" changes it (Oscar S contact center)
        //I have no idea what im doing just adding more so it won't be 0 and it shows something since they want it
        const amountCC =
            immValues.get('quantity') +
            immFunds.get('quantity') +
            immPlans.get('quantity') +
            immWealthRoboValues.get('cantidadCuentasGD');

        const amount =
            !__CONTACT_CENTER__ ?
            immValues.get('quantity') +
            immFunds.get('quantity') +
            immPlans.get('quantity') +
            immFutures.get('quantity') +
            immWealthRoboValues.get('cantidadCuentasGD') : amountCC;
        const investmentsClass = classnames(
          "global-position-investments",
          {
            "global-position-investments--is-clickable": !expanded
          }
        );

        let allItemsExcluded = false;
        let products = this.getProducts();

        if(!__CONTACT_CENTER__ && amount === 0) {
            allItemsExcluded = true;

            if(isRoboEnabled && !!immWealthRoboValues.get('totalDiscrecionalAmount') ) {
                allItemsExcluded = false;
                products = this.getProducts(true);
            }
        }

        if (!flagBasedFeatures.get(YOUR_INVESTMENTS)) {
            products = this.getProducts(true);
        }

        return (
            <section className={investmentsClass} onClick={!expanded ? this.handleBoxClick : undefined}>
                <GlobalPositionFinancialCard
                    id={this.props.id}
                    icon="rebrand-investments"
                    amount={!__CONTACT_CENTER__ ? amount : amountCC}
                    cards={products}
                    currencyDetails={total}
                    showMoreText={formatText('myGlobalPosition-creditCardShowMore')}
                    showMoreLink="/myprofile/broker/general"
                    subtitle={subtitle}
                    title={formatText('myGlobalPosition-myGlobalPosition_wealth')}
                    expanded={expanded}
                    titleLink="/myprofile/broker/general"
                    hasExcludedItems={hasExcludedItems}
                    allItemsExcluded={!__CONTACT_CENTER__ ? allItemsExcluded : amountCC === 0}
                    emptyStateMessage={formatText('myGlobalPosition-allInvestmentProductsExcluded')}
                    productModifier={OPENBANK_PRODUCT_WEALTH}
                    alternativeContentCC={GlobalPositionInvestmentsContentCC}
                    keepExpandedStyle={hasCryptoAssets}
                />
            </section>
        );
    }
}

GlobalPositionInvestments.propTypes = {
    expanded: PropTypes.bool,
    history: PropTypes.object.isRequired,
    id: PropTypes.string,
    immWalletSummarization: PropTypes.object.isRequired,
    immWealthRoboValues: PropTypes.object.isRequired,
    isRoboEnabled: PropTypes.bool,
    flagBasedFeatures: PropTypes.object.isRequired,
    immFlagBasedMBFeatures: PropTypes.object.flagBasedMBFeatures,
    wealthDataFF: PropTypes.object,
    wealthErrorFF: PropTypes.bool,
};

module.exports = withRouter(GlobalPositionInvestments);
